// extracted by mini-css-extract-plugin
export default {"dlAutoLayoutBox":"src-js-containers-auto_layout-components-AutoLayoutBox---dlAutoLayoutBox---My66a"};